import React, { useState, useEffect, useRef } from "react";
import Content from "../../../layout/content/Content";
import { Spinner } from "reactstrap"
import {
    Block,
    BlockDes,
    BlockHead,
    Button,
} from "../../../components/Component";
import Swal from "sweetalert2";
import Head from "../../../layout/head/Head";
import Center from "./Center";

const Recheck = ({ ...props }) => {
    const [transData, setTransData] = useState([]);
    const [activedata, setactivedata] = useState([]);
    const [onSearchText, setSearchText] = useState("");
    const month1 = ["Test", "JANUARY", "FEBRUARY", "MARCH", "APRIL", "MAY", "JUNE", "JULY", "AUGUST", "SEPTEMBER", "OCTOBER", "NOVEMBER", "DECEMBER"]
    const [lorder, setLorder] = useState(true);
    const [data, setData] = useState(transData);
    const tableRef = useRef(null);

    const getdata = async () => {
        const sendData = {
            UserRoleId:Number(localStorage.getItem('urole')),   

        }
       

        await fetch(process.env.REACT_APP_API_LINK + 'api/Data/Recheckdata', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {
                    //console.log(data)
                    setactivedata(data)
                    setLorder(false)
                })


    };
    const Approve = async (emp) => {

        Swal.fire({
            title: 'Are You Sure you want to Approve  ?',
            icon: 'question',
            showDenyButton: true,
            showCancelButton: false,
            confirmButtonText: 'Yes',
            confirmButtonColor: 'success',
            denyButtonText: `No`,
        }).then(async (result) => {
            //console.log(emp)

            if (result.isConfirmed) {
                const sendData = {

                    EmploymentId: Number(emp),
                }

                //console.log(sendData)
                await fetch(process.env.REACT_APP_API_LINK + 'api/Data/Recheck', {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(sendData)

                })
                    .then(response => response.json())
                    .then(
                        data => {
                            if (data === "Done") {
                                window.location.reload()
                            } else {
                                Swal.fire({
                                    title: 'Data Not Submitted',
                                    icon: 'error',

                                })
                            }

                        })


            } else if (result.isDenied) {
                getdata()
            }
        })



    };
    



    // Changing state value when searching name
    useEffect(() => {
        if (onSearchText !== "") {
            const filteredObject = transData.filter((item) => {

                return item.organizationName.toLowerCase().includes(onSearchText.toLowerCase()) || item.phoneNo.toLowerCase().includes(onSearchText.toLowerCase()) || item.emailId.toLowerCase().includes(onSearchText.toLowerCase());
            });
            setData([...filteredObject]);
        }
        else {
            setData([...transData]);
        }

    }, [onSearchText]);


    useEffect(() => {

        getdata()
        
    }, [])






    return (
        <React.Fragment>
            <Head title="AllUser" />

            <Content>


                <Block>

                    <BlockHead size="lg">

                        <BlockDes className="text-soft">


                            <h3 style={{ textAlign: 'center' }}>Re-edit Request made by District Employment Exchange</h3>

                        </BlockDes>


                    </BlockHead>


                    <div className="table-responsive">
                        <table className="table table-orders" ref={tableRef}>
                            <thead className="tb-odr-head">
                                <tr className="tb-odr-item" style={{ textAlign: 'center' }}>

                                    <th >
                                        SNo

                                    </th>
                                    <th >
                                       Form Name

                                    </th>
                                    <th >
                                       Center Name

                                    </th>
                                    <th >
                                        Month

                                    </th>
                                    <th >
                                        Year

                                    </th>
                                    <th >
                                        ReCheck

                                    </th>
                                  



                                </tr>


                            </thead>
                            {activedata.length>=0 ? activedata.map((details, index) =>
                                <tr style={{ textAlign: 'center' }}>
                                  <td  >
                                        
                                            <b style={{ color: '#6576ff', fontSize: 18 }}>{index + 1}</b>
                                   
                                    </td>
                                    <td  >
                                      
                                            <b style={{ color:'#6576ff' , fontSize: 18 }}>{details.name}</b>
                                     
                                    </td>
                                    <Center userId={details.userId}/>
                                    
                                    <td> <b style={{ fontSize: 18 }}>{month1[details.monthId]}</b></td>
                                    <td> <b style={{ fontSize: 18 }}>{details.yearId}</b></td>
                                    <td><Button color='success' onClick={() => Approve(details.employmentId)}> <b style={{ fontSize: 18 }}> Recheck <em class="icon ni ni-repeat-fill"></em> </b></Button></td>

                                </tr>
                            ) : <Spinner color="success" />}





                        </table>

                    </div>




                </Block>




            </Content>

        </React.Fragment>
    );
};

export default Recheck;
